import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {I18NService} from '../../../../shared/i18n/i18n.service';
import {SergasDeviceService} from '../sergas-device.service';
import {SergasDevice} from '../sergasDevice';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {IPlaceValuelistService} from '../../../../iPlace/iPlace-valuelist.service';
import {SectionService} from '../../../section/Section.service';
import {Section} from '../../../section/Section';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-monitored-equipment',
  templateUrl: './monitored-equipment-list.component.html',
  styleUrls: ['./monitored-equipment-list.component.css']
})
export class MonitoredEquipmentListComponent implements OnInit {

  tableMessages: any;
  sergasDevicePage: any;
  sorts = [{prop: 'created', dir: 'desc'}];
  rows: SergasDevice[] = [];
  search: string;
  private searchText= '';
  private searchTerms = new Subject<string>();

  isLoadingResults = true;

  dropdowniPlaceList:any = [];
  selectediPlaces:any = [];
  dropdowniPlaceSettings:any = {};
  itemTags: any[] = [];
  iPlaceList:any[] = [];
  iPlaceMap:any[];

  selectedSections:any = [];
  sectionMap:any[];
  selectedSectionId:string = "";
  sections: any[] = [];
  sectionsMap: any = {};
  sectionTree: any;

  modalRef: BsModalRef;
  @ViewChild('newSergasDeviceTemplate', { static: true })
  private newSergasDeviceTempRef: TemplateRef<any>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private i18nService: I18NService,
    private iPlaceValuelistService: IPlaceValuelistService,
    private sectionService: SectionService,
    private sergasDeviceService: SergasDeviceService,
    private modalService: BsModalService
  ) {

    this.sergasDevicePage = {
      count: 0,
      pageSize: 15,
      offset: 0,
    };

    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((result) => {
        this.searchText = result.toUpperCase();
        this.sergasDevicePage.pageSize = 15;
        this.sergasDevicePage.offset = 0;
        this.setMonitoredEquipmentPage(this.sergasDevicePage);
      });

    this.route.params.subscribe((params: Params) => {
      if (params["filter"]) {
        this.searchText = params["filter"].toUpperCase();
        this.search = params["filter"];
      }
    });

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");

    /* iPlace Dropdown */
    if ( (<any>Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
        previous[current.id] = current;
        return previous;
      }, {})
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => {
          this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
            .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
            previous[current.id] = current;
            return previous;
          }, {});
          this.dropdowniPlaceList = this.iPlaceList;
        })
    }

    let groupBy = null;
    this.dropdowniPlaceList = this.iPlaceList;

    this.dropdowniPlaceSettings = {
      singleSelection: true,
      enableCheckAll: false,
      enableFilterSelectAll: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectiPlaces"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: groupBy,
      classes: "form-angular2-multiselect"
    };

    this.setMonitoredEquipmentPage(this.sergasDevicePage);
  }

  ngOnInit() {
  }

  private getSectionsByiPlace() {
    let iPlaceIds = this.selectediPlaces.length ? this.selectediPlaces[0].idiPlace : null;
    this.selectedSections = [];

    if(iPlaceIds != null) {
      this.sectionService.get(iPlaceIds).then(response => {
        this.sections = response
          .sort((a, b) => a.localSectionId < b.localSectionId ? -1 : a.localSectionId > b.localSectionId ? 1 : 0);
        this.sectionTree = this.getSectionTree(response);
        this.sectionsMap = this.sections.reduce((previous:any, current:any) => {
          previous[current.id] = current;
          return previous;
        }, {});
      });
    } else {
      this.sections = [];
      this.sectionTree = null;
      this.sectionsMap = null;
      this.selectedSections = [];
      this.selectedSectionId = null;
    }
  }

  private getSectionTree(sections: Section[]) {
    let sectionsMap = sections.reduce(function(map, section) {
      map[section.sectionId] = section;
      section['children'] = [];
      section['value'] = section.name;
      return map;
    }, {});

    sections.forEach(section => {
      if ( section.parentSectionId ) {
        let parent = sectionsMap[section.parentSectionId];
        if ( parent ) {
          parent.children.push(section);
        }
      }
    });
    sections.forEach((section:any) => {
      section.children = section.children.sort( (a:any,b:any) => a.name.localeCompare(b.name))
    });
    return sections[0];
  }

  setMonitoredEquipmentPage(pageInfo:any){
    this.isLoadingResults = true;
    let filter = "";

    if ( this.searchText ) {
      let or = filter ? ";" : "";
      filter += this.searchText ? or + "|deviceName:ilike:" + this.searchText : "";
    }
    if ( this.selectediPlaces && this.selectediPlaces.length ) {
      let or = filter ? ";" : "";
      filter +=  or + "iPlaceId:in:" + this.selectediPlaces.map(e => e.idiPlace).join(",");
    }
    if ( this.selectedSections && this.selectedSections.length ) {
      let or = filter ? ";" : "";
      filter +=  or + "sectionId:in:" + this.selectedSections.map(e => e.sectionId).join(",");
    }

    let sort =  this.sorts[0].prop + "," + this.sorts[0].dir;

    this.sergasDeviceService.getPage(pageInfo.offset, pageInfo.pageSize - 1, sort, filter)
      .then( response => {
        this.isLoadingResults = false;
        let sort = response.sort ? response.sort[0].property + "," + response.sort[0].direction : "";
        this.sergasDevicePage = {
          count: response.totalElements,
          pageSize: response.size,
          offset: response.number
        };
        this.rows = response.content;
        this.sorts = [{prop: response.sort[0].property, dir: response.sort[0].direction.toLowerCase()}];
      })
      .catch( error => {
        this.isLoadingResults = false;
      });
  }

  onSearch(term: string){
    this.searchTerms.next(term);
  }

  oniPlaceSelect(item: any) {
    console.log(item);
    this.sergasDevicePage.pageSize = 15;
    this.sergasDevicePage.offset = 0;
    this.setMonitoredEquipmentPage(this.sergasDevicePage);
    this.getSectionsByiPlace();
  }

  onDeSelectAlliPlaces(items: any) {
    this.sergasDevicePage.pageSize = 15;
    this.sergasDevicePage.offset = 0;
    this.selectediPlaces = [];
    this.getSectionsByiPlace();
    this.setMonitoredEquipmentPage(this.sergasDevicePage);
  }

  onSectionSelect(e:any){
    this.selectedSections = [e];
    this.selectedSectionId = e.sectionId;
    this.setMonitoredEquipmentPage(this.sergasDevicePage);
  }

  onSectionDeSelect(event: MouseEvent){
    event.stopImmediatePropagation();
    this.selectedSections = [];
    this.selectedSectionId = null;
    this.setMonitoredEquipmentPage(this.sergasDevicePage);
  }

  viewDetail(sergasDeviceId) {
    this.router.navigate([sergasDeviceId], {relativeTo: this.route});
  }

  hide() {
    this.modalService.hide(1);
  }

  createNewSergasDevice() {
    this.router.navigate(["new"], {relativeTo: this.route});
  }

}
